(() => {
  const root = document.documentElement;
  root.classList.add('rf-brand-ready');

  const revealItems = [...document.querySelectorAll('[data-rf-reveal]')];
  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  revealItems.forEach((item) => observer.observe(item));

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-rf-reveal]').forEach((item) => {
      item.classList.add('is-visible');
    });
  });
})();
